import { Link, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { RuteroPickupTimeVerification } from '@bandido/shared/types';

export function PickupVerificationNotice({ verification }: { verification?: RuteroPickupTimeVerification }) {
  const { t } = useTranslation();
  if (!verification?.required) return null;
  return (
    <Stack spacing={0.5}>
      <Typography variant="body2" color="warning.dark">
        {t('travelServices.legs.verifyPickup')}
      </Typography>
      {verification.availableHoursBefore !== undefined && (
        <Typography variant="body2">
          {t('travelServices.legs.verificationAvailable', { hours: verification.availableHoursBefore })}
        </Typography>
      )}
      {verification.url && (
        <Link href={verification.url} target="_blank" rel="noopener noreferrer" variant="body2">
          {t('travelServices.legs.pickupReconfirmLink')}
        </Link>
      )}
    </Stack>
  );
}
